import React, { useEffect } from "react"
import { useInView } from 'react-intersection-observer'

const InViewObserverForSideMenu = ({targetLiId}) => {
  const {ref, inView} = useInView({
    rootMargin: '5px',
  })

  useEffect(() => {
    const li = document.getElementById(targetLiId)
    if(li !== null) {
      inView ? li.classList.add('current') : li.classList.remove('current')
    }
  }, [inView])

  return (
    <>
    <div ref={ref}></div>
    </>
  )
}

export default InViewObserverForSideMenu
